import { ExitEditingChoice } from '@/features/dashboard/bookingChanges/types/ChangePackageFlowViewModel.ts';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import { buildDiscardHint } from './exitEditingSummary';

/** Wybór w modalu: etykieta po lewej, dopisek po prawej — jeden przycisk przepływu. */
const ChoiceButton = ({
  hint,
  hintClassName,
  children,
  ...props
}: React.ComponentProps<typeof ActionButton> & {
  hint: string;
  hintClassName: string;
}) => (
  <ActionButton
    size="block"
    className="flex items-center gap-3 text-left"
    {...props}
  >
    <span className="flex-1">{children}</span>
    <span className={hintClassName}>{hint}</span>
  </ActionButton>
);

interface ExitEditingChoicesProps {
  /** Do dopisku przy odrzuceniu — ile pozycji przepadnie. */
  itemCount: number;
  onChoice: (choice: ExitEditingChoice) => void;
  /** Odrzucanie szkicu w toku — przyciski nie przyjmują drugiego kliknięcia. */
  isDiscarding?: boolean;
}

/** Trzy wyjścia ze szkicu: wprowadź, zapisz na później, odrzuć. */
const ExitEditingChoices = ({
  itemCount,
  onChoice,
  isDiscarding = false,
}: ExitEditingChoicesProps) => (
  <div className="flex flex-col gap-2.5 px-7 pb-[22px] pt-5">
    <ChoiceButton
      autoFocus
      tone="accent"
      disabled={isDiscarding}
      onClick={() => onChoice(ExitEditingChoice.APPLY)}
      hint="zmiany wchodzą w życie"
      hintClassName="text-sm font-semibold opacity-70"
    >
      Wprowadź paczkę
    </ChoiceButton>

    <ChoiceButton
      tone="neutral"
      disabled={isDiscarding}
      onClick={() => onChoice(ExitEditingChoice.SAVE_DRAFT)}
      hint="wrócisz do niego później"
      hintClassName="text-sm text-neutral-500"
    >
      Zapisz szkic i wyjdź
    </ChoiceButton>

    <ChoiceButton
      tone="danger"
      disabled={isDiscarding}
      onClick={() => onChoice(ExitEditingChoice.DISCARD)}
      hint={buildDiscardHint(itemCount)}
      hintClassName="text-sm text-error-200"
    >
      Odrzuć szkic
    </ChoiceButton>
  </div>
);

export default ExitEditingChoices;
